import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Facsimile } from "../../types"
import FacsimileForm from "./FacsimileForm"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { initialValuesFacsimile, validationSchemaFacsimile } from "./FacsimileCommon"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import ModalDelete from "../../components/ModalDelete"
import { useMemo } from "react"
import { useFacsimile, useFacsimileDelete, useFacsimileUpdate } from "../../hooks/facsimili"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function FacsimileUpdate() {
  const updateFacsimile = useFacsimileUpdate()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: facsimile } = useFacsimile(Number(id))

  const [modalStateDeleteFacsimile, modalActionsDeleteFacsimile] = useModalTrigger()

  const deleteFacsimile = useFacsimileDelete()

  const initialValues = useMemo(() => initialValuesFacsimile(facsimile), [facsimile])
  const validationSchema = useMemo(() => validationSchemaFacsimile(true), [])

  useBreadcrumbs([{ label: "Facsimili", href: "/edizioni/facsimili" }, { label: "Dettaglio Facsimile" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{facsimile?.titolo}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteFacsimile.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return updateFacsimile.mutateAsync(values as Facsimile).then(() => {
                navigate(`/edizioni/facsimili`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <FacsimileForm showEdizione col={8} />
                </Container>
                <BottomFormFixed url="/edizioni/facsimili" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteFacsimile.isOpen}
        onClose={modalActionsDeleteFacsimile.close}
        onDelete={() => {
          return deleteFacsimile.mutateAsync(facsimile?.id).then(() => {
            navigate(`/edizioni/facsimili`)
          })
        }}
        message="Sei sicuro di voler eliminare questo facsimile?"
        title="Elimina facsimile"
      />
    </Layout>
  )
}
